// `/notes?note=` — which note is open, in the URL.
//
// So a search result links to the note it found rather than to a list the
// reader has to scan again for it.

export interface NotesPageSearch {
  note?: string;
}

/** Never throws: a malformed URL opens nothing, rather than crashing the screen. */
export function validateNotesSearch(raw: Record<string, unknown>): NotesPageSearch {
  const note = raw["note"];
  return typeof note === "string" && note !== "" ? { note } : {};
}
